import { render } from "./ServiceBovineCard.vue?vue&type=template&id=403a582a&scoped=true"
import script from "./ServiceBovineCard.vue?vue&type=script&lang=js"
export * from "./ServiceBovineCard.vue?vue&type=script&lang=js"

import "./ServiceBovineCard.vue?vue&type=style&index=0&id=403a582a&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403a582a"]])

export default __exports__